import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatINR, formatDate, formatMonth } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Download } from "lucide-react";

export default function EmployeeDetail() {
  const { id } = useParams();
  const [e, setE] = useState(null);
  const [from, setFrom] = useState(""); const [to, setTo] = useState("");
  useEffect(() => { api.get(`/employees/${id}`).then(({ data }) => setE(data)); }, [id]);
  const downloadPdf = async () => {
    const res = await api.get(`/employees/${id}/statement`, { params: { date_from: from || undefined, date_to: to || undefined }, responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `statement_${e.employee_id}.pdf`; a.click();
  };
  if (!e) return <div>Loading…</div>;
  return <div className="space-y-6" data-testid="employee-detail">
    <div className="flex items-start justify-between flex-wrap gap-4">
      <div><div className="overline">Employee</div><h1 className="font-serif text-4xl mt-1">{e.name}</h1>
        <div className="mt-2 text-sm text-muted-foreground">
          <span className="font-mono">{e.employee_id}</span> · {e.branch_name} · <span className={`pill pill-${e.status.toLowerCase()}`}>{e.status}</span> · {e.phone} · Salary <b className="font-mono">{formatINR(e.monthly_salary)}</b>
        </div>
      </div>
      <div className="flex items-end gap-2">
        <div><label className="overline">From</label><Input type="date" value={from} onChange={x => setFrom(x.target.value)} data-testid="stmt-from" /></div>
        <div><label className="overline">To</label><Input type="date" value={to} onChange={x => setTo(x.target.value)} data-testid="stmt-to" /></div>
        <Button className="gold-bg" onClick={downloadPdf} data-testid="download-statement"><Download className="w-4 h-4 mr-2" />PDF Statement</Button>
      </div>
    </div>
    <div className="grid md:grid-cols-4 gap-4">
      <div className="kpi-card"><div className="overline">Total Advanced</div><div className="font-serif text-3xl tabular-nums mt-2">{formatINR(e.total_advanced)}</div></div>
      <div className="kpi-card"><div className="overline">Total Repaid</div><div className="font-serif text-3xl tabular-nums mt-2">{formatINR(e.total_repaid)}</div></div>
      <div className="kpi-card"><div className="overline">Bad Debt</div><div className="font-serif text-3xl tabular-nums mt-2 text-red-400">{formatINR(e.total_bad_debt)}</div></div>
      <div className="kpi-card"><div className="overline">Active Outstanding</div><div className="font-serif text-3xl tabular-nums mt-2 gold">{formatINR(e.outstanding)}</div></div>
    </div>
    <div>
      <h2 className="font-serif text-2xl mb-3">Ledger</h2>
      <div className="border rounded-md overflow-x-auto"><table className="plutus"><thead><tr>
        <th>Date</th><th>Description</th><th>Payroll</th><th className="text-right">Advance</th><th className="text-right">Repayment</th><th className="text-right">Bad Debt</th><th className="text-right">Running Balance</th></tr></thead>
        <tbody data-testid="ledger">{e.ledger.map(l => <tr key={l.id + l.type}>
          <td className="font-mono text-xs">{formatDate(l.date)}</td><td>{l.description}</td><td className="font-mono text-xs">{l.payroll_month ? formatMonth(l.payroll_month) : "-"}</td>
          <td className="text-right tabular-nums">{l.type === "Advance" ? formatINR(l.amount) : ""}</td>
          <td className="text-right tabular-nums">{l.type === "Repayment" ? formatINR(l.amount) : ""}</td>
          <td className="text-right tabular-nums text-red-400">{l.type === "BadDebt" ? formatINR(l.amount) : ""}</td>
          <td className="text-right tabular-nums gold">{formatINR(l.running_balance)}</td></tr>)}
        {e.ledger.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-muted-foreground">No transactions yet.</td></tr>}</tbody>
        <tfoot data-testid="ledger-totals"><tr className="border-t border-border font-medium">
          <td className="font-mono text-xs" colSpan={3}>Total up to {formatDate(new Date().toISOString())}</td>
          <td className="text-right tabular-nums">{formatINR(e.total_advanced)}</td>
          <td className="text-right tabular-nums">{formatINR(e.total_repaid)}</td>
          <td className="text-right tabular-nums text-red-400">{formatINR(e.total_bad_debt)}</td>
          <td className="text-right tabular-nums gold">{formatINR(e.outstanding)}</td></tr></tfoot></table></div>
    </div>
  </div>;
}
